function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */
import PairingChannelClientErrors from './pairing-channel-client-errors';
import { Model } from 'backbone';
import { pick } from 'underscore';
import { base64urlToUint8Array } from './crypto/util';
import importFxaPairingChannel from './fxa-pairing-channel';
import * as Sentry from '@sentry/browser';
import Vat from 'lib/vat';
const PAIRING_MESSAGE_DATA_SCHEMA = {
  data: Vat.any(),
  message: Vat.string().required()
};
const PAIRING_MESSAGE_SENDER_SCHEMA = {
  city: Vat.string(),
  country: Vat.string(),
  region: Vat.string(),
  remote: Vat.string(),
  ua: Vat.string()
};
/**
 * The client that handles the connectivity with the channel server.
 * It uses the fxa-pairing-channel module to connect, receive and send messages.
 *
 * @export
 * @class PairingChannelClient
 * @extends {Model}
 */

let PairingChannelClient = /*#__PURE__*/function (_Model) {
  _inherits(PairingChannelClient, _Model);

  var _super = _createSuper(PairingChannelClient);

  function PairingChannelClient() {
    var _this;

    let attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PairingChannelClient);

    _this = _super.call(this, attrs, options);
    _this.sentryMetrics = options.sentryMetrics || Sentry;
    _this._importPairingChannel = options.importPairingChannel || importFxaPairingChannel;
    return _this;
  }
  /**
   * Open a socket to `channelId` on `channelServerUri` with a given `channelKey`.
   *
   * @param {String} [channelServerUri=this.get('channelServerUri')]
   * @param {String} [channelId=this.get('channelId')]
   * @param {String} [channelKey=this.get('channelKey')]
   * @returns {Promise} resolves when connected
   */


  _createClass(PairingChannelClient, [{
    key: "open",
    value: function open() {
      let channelServerUri = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.get('channelServerUri');
      let channelId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.get('channelId');
      let channelKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.get('channelKey');
      return this._importPairingChannel().then(FxAccountsPairingChannel => {
        if (this.channel) {
          // to avoid opening a duplicate connection, say the client is connected
          // if a socket exists but isn't yet connected.
          throw PairingChannelClientErrors.toError('ALREADY_CONNECTED');
        }

        if (!channelServerUri || !channelId || !channelKey) {
          throw PairingChannelClientErrors.toError('INVALID_CONFIGURATION');
        }

        const psk = base64urlToUint8Array(channelKey);
        return FxAccountsPairingChannel.PairingChannel.connect(channelServerUri, channelId, psk).then(channel => {
          this.channel = channel;
          this.trigger('connected');
          this.channel.addEventListener('message', this._messageHandler.bind(this));
          this.channel.addEventListener('error', this._errorHandler.bind(this));
          this.channel.addEventListener('close', this._closeHandler.bind(this));
        }).catch(err => {
          this.sentryMetrics.captureException(err);
          this.trigger('error', err);
        });
      });
    }
    /**
     * Close the channel.
     *
     * @returns {Promise} - rejects if no socket, resolves when connection closed
     */

  }, {
    key: "close",
    value: function close() {
      return Promise.resolve().then(() => {
        if (!this.channel) {
          throw PairingChannelClientErrors.toError('NOT_CONNECTED');
        }

        return this.channel.close().then(() => {
          this.channel = null;
        }, err => {
          this.channel = null;
          this.sentryMetrics.captureException(err);
        });
      });
    }
    /**
     * Send `message` with `data` to the remote.
     *
     * @param {String} message name of message to send
     * @param {Any} [data={}]
     * @returns {Promise} resolves when complete
     */

  }, {
    key: "send",
    value: function send(message) {
      let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.channel) {
        return Promise.reject(PairingChannelClientErrors.toError('NOT_CONNECTED'));
      }

      if (!message) {
        return Promise.reject(PairingChannelClientErrors.toError('INVALID_OUTBOUND_MESSAGE'));
      }

      return this.channel.send({
        data,
        message
      });
    }
    /**
     * Handle a message. Expects a message with the
     * following format:
     *
     * ```
     * event.detail = {
     *   "data": {
     *     "data": <message data>,
     *     "message": <message name>,
     *   },
     *   "sender": {
     *     "city": <sender's city name>,
     *     "country": <sender's country name>,
     *     "region": <sender's region>,
     *     "ua": <sender's user agent string>,
     *   }
     * }
     * ```
     *
     * An `error` message will be triggered if there is an error
     * parsing or decrypting the message.
     *
     * @param {Object} event
     * @private
     */

  }, {
    key: "_messageHandler",
    value: function _messageHandler(event) {
      try {
        const _event$detail = event.detail,
              payload = _event$detail.data,
              sender = _event$detail.sender;
        const validateData = Vat.validate(payload, PAIRING_MESSAGE_DATA_SCHEMA);
        const validateSender = Vat.validate(sender, PAIRING_MESSAGE_SENDER_SCHEMA);

        if (validateData.error || validateSender.error) {
          throw PairingChannelClientErrors.toError('INVALID_MESSAGE');
        }

        const _payload$data = payload.data,
              data = _payload$data === void 0 ? {} : _payload$data,
              message = payload.message;
        data.remoteMetaData = pick(sender, 'city', 'country', 'region', 'ua');
        data.remoteMetaData.ipAddress = sender.remote;
        this.trigger(`remote:${message}`, data);
      } catch (err) {
        this.sentryMetrics.captureException(err);
        this.trigger('error', err);
      }
    }
    /**
     * An error event returned from the fxa-pairing-channel
     * @param {Object} event
     * @private
     */

  }, {
    key: "_errorHandler",
    value: function _errorHandler(event) {
      this.sentryMetrics.captureException(event.detail);
      this.trigger('error', PairingChannelClientErrors.toError('UNEXPECTED_ERROR'));
    }
    /**
     * A close event returned from the fxa-pairing-channel
     * @param {Object} event
     * @private
     */

  }, {
    key: "_closeHandler",
    value: function _closeHandler(event) {
      this.trigger('close');
    }
  }]);

  return PairingChannelClient;
}(Model);

export { PairingChannelClient as default };